import { Avatar, Box, Typography, useTheme } from "@mui/material";
import logoWhite from '@/assets/logo-white.svg';
import logoBlack from '@/assets/logo.svg';
import useLayout from "@/features/layout/useLayout";
import { Link as RouterLink } from "react-router";

const VerticalMenuHeader = () => {
  const { isSidebarCollapsed } = useLayout();
  const theme = useTheme()
  const activeLogo = theme.palette.mode === 'dark' ? logoWhite : logoBlack
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: isSidebarCollapsed ? 'space-between' : 'center',
        px: isSidebarCollapsed ? 1.25 : 1,
        py: 1
      }}
    >
      <Box sx={{ p: 1, width: '100%' }}>
        <Box
          component={RouterLink}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            userSelect: 'none',
            '&:link, &:visited': {
              color: 'inherit',
            },
          }}
        >
          <Avatar 
            src={activeLogo} 
            alt="" 
            sx={{ 
              width: 26, 
              height: 26,
              userSelect: 'none',
              // marginX: 'auto',
            }} 
            slotProps={{
              img: {
                draggable: "false"
              }
            }}
          />
          {
            isSidebarCollapsed && (
            <Typography 
              variant="subtitle2" 
              noWrap 
              sx={{
                fontWeight: 600
              }}
            >
              Ai Parking
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default VerticalMenuHeader;